/*
  Bedragen in de taal van de bezoeker, in centen: zodat "€11,97", "€11.97" en "11,97 €" overal op
  de productpagina gelijk zijn. Shopify's `| money` gebruikt één vaste notatie voor de hele winkel.

    window.zawajMoney.format(1797, { locale: 'nl', currency: 'EUR' })            // "€17,97"
    window.zawajMoney.format(500, { locale: 'de', currency: 'EUR', compact: true }) // "5 €"
*/

if (!window.zawajMoney) {
  const formatters = {};

  window.zawajMoney = {
    format(cents, { locale, currency, compact = false }) {
      const key = [locale, currency, compact].join('|');
      formatters[key] =
        formatters[key] ||
        new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          minimumFractionDigits: compact ? 0 : undefined,
        });
      // "€ 17,95" -> "€17,95", zoals de rest van het thema; "17,95 €" blijft staan.
      return formatters[key].format(cents / 100).replace(/^(\D+?)\s+(\d)/, '$1$2');
    },
  };
}
